import config from '@/config/global';

const footerLinks = config.footerLinks;

export default footerLinks;
